import React, { useCallback, useContext } from 'react';
import { observer } from 'mobx-react';
import { Box, Button, makeStyles } from '@material-ui/core';
import { Star } from '@material-ui/icons';

import AnchorLiveFeedStatusBar from '../AnchorLiveFeedStatusBar/AnchorLiveFeedStatusBar';
import GroupShowStore from '../../../../store/GroupShowStore';
import { isSubscribedToGroupShowAnchor } from '../../../../utils/helpers';
import { RootStoreContext } from '../../../../context';
import classnames from 'classnames';


import './css/AnchorLiveFeedHeader.css';
import './css/AnchorLiveFeedHeader.mobile.css';
import LiveBroadcastStore from '../../../../store/LiveBroadcastStore';


const useStyles = makeStyles(() => {
  return { tipButton: { color: '#fff' } };
});

const AnchorLiveFeedHeader = ({
  setTippingModal,
  anchor,
  isAlreadySubscribedToAnchor,
  anchorVideoUrl,
  roomCount,
  broadcasterClosedSession,
  spotlighterClosedSession,
  isGuest,
  user,
  isAnchor,
  history,
  isSpotlighing,
  spotlighedAnchorNickname,
  spotlighedAnchorUsername,
  spotlightedByTemptationUsername,
}) => {
  const {
    isInGroupShow,
    username,
    groupShowParticipant: {
      anchorDetails,
      participantUsername,
      isFromTempted,
    },
  } = GroupShowStore;
  let isSubscribedToGroupShowParticipant = false;
  const classes = useStyles();
  const context = useContext(RootStoreContext);
  const { tippingStore } = context;

  if (isInGroupShow && anchorDetails) {
    isSubscribedToGroupShowParticipant = isSubscribedToGroupShowAnchor(user, anchorDetails.id);
  }

  const { isSpotlight, spotlightedByAnchorNickname } = LiveBroadcastStore;
  let tipSpotlightAnchorUsername = {};

  if (isSpotlight && !isSpotlighing && spotlightedByAnchorNickname !== anchor.username) {
    tipSpotlightAnchorUsername.nickname = spotlightedByAnchorNickname;
    tipSpotlightAnchorUsername.username = spotlightedByTemptationUsername;
  } else if (isSpotlighing) {
    tipSpotlightAnchorUsername.nickname = spotlighedAnchorNickname;
    tipSpotlightAnchorUsername.username = spotlighedAnchorUsername;
  }
  const canSubscribeToParticipant = !isSubscribedToGroupShowParticipant && !isAnchor;

  const redirectToSubscribePage = useCallback(async (participantUsername) => {
    if (isFromTempted) {
      window.open(`https://tempted.com/profile/${anchorDetails.nickname}`);
    } else {
      const response = await GroupShowStore.getAnchorByUsername(participantUsername);
      if (response.data) {
        const { name } = response.data.data;
        const { id } = response.data.data;

        const anchorName = name.toLowerCase().split(' ').join('-');
        const anchorShortUrl = `naked-news-anchor-${anchorName}-a${id}`;

        history.push(`/account/purchase?_anchor=${id}&_shortUrl=${anchorShortUrl}`);
      }
    }
  }, [isFromTempted, anchorDetails]);

  return (
    <>
      {(anchorVideoUrl || isInGroupShow) && (
        <div className="is-mobile">
          <div className={classnames({
            'broadcast-viewer-header': true,
            'hide': !isAlreadySubscribedToAnchor,
            'no-padding': isAlreadySubscribedToAnchor,
          })}>
            {isAlreadySubscribedToAnchor && (!isSpotlight && !isInGroupShow && !broadcasterClosedSession) && (
              <>
                <Box width={80}>
                  <Button className="already-subscribed" justifyContent="flex-end" width={80}>
                    <Star />
                    Fan
                  </Button>
                </Box>
                <Button
                  className={classes.tipButton}
                  onClick={() => tippingStore.setTippingModal({ name: anchor.name, username: anchor.username, id: anchor.id })}
                >
                  TIP {anchor.name}
                </Button>
              </>
            )}
          </div>
          {isSpotlight && tipSpotlightAnchorUsername && (
            <div className="broadcast-viewer-header broadcast-viewer-header-spotlight">
              {!isGuest && !isAnchor && (
                <button
                  className="btn btn-red" onClick={() => {
                    tippingStore.setTippingModal({ username: anchor.username }, tipSpotlightAnchorUsername?.nickname, tipSpotlightAnchorUsername?.username);
                  }}
                >
                  TIP $
                </button>
              )}
            </div>
          )}
          {isInGroupShow && ((anchorDetails.name || anchorDetails.nickname) || isAlreadySubscribedToAnchor) && (
            <div className="broadcast-viewer-header broadcast-viewer-header-participant">
              {!isGuest && !isAnchor && (
                <button
                  className="btn btn-red" onClick={() => {
                      setTippingModal({ username: username || anchor.username }, participantUsername, anchorDetails.nickname);
                  }}
                >
                  TIP $
                </button>
              )}
            </div>
          )}
          {!broadcasterClosedSession && !spotlighterClosedSession && (
            <AnchorLiveFeedStatusBar
              anchorDetails={anchorDetails}
              isInGroupShow={isInGroupShow}
              roomCount={roomCount}
            />
          )}
        </div>
      )
      }

    </>
  );
};

export default observer(AnchorLiveFeedHeader);
